import React, { useEffect, useState } from "react";
import logo from "../booking/images/conrad-logo.png";
import "./mainLayout.css";

interface Props {
  children: React.ReactNode;
}

const MainLayout: React.FC<Props> = ({ children }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div className="main-wrapper">
      <div className="hero-section">
        <div className="hero-overlay" />

        <div className="logo-container-hotel">
          <img
            src="https://res.cloudinary.com/astcdubai/image/upload/v1736164746/45th_Ica_white_logo_xoggsq.png"
            alt="ICA Logo"
            className="ica-logo"
          />
          
          {!isMobile && <img
            src={logo}
            alt="Conrad Logo"
            className="ica-logo"
          /> }
        </div>

        <div className="hero-content">
          <h1 className="hero-title">
            Your Stay, Elevated — at{" "}
            <span className="highlight">Conrad Dubai</span>
          </h1>
          <p className="hero-subtitle">
            In proud partnership with the{" "}
            <strong style={{ color: "#fcd34d" }}>
              48th ICA Conference & Exhibition
            </strong>
            , enjoy world-class hospitality at our official accommodation venue.
          </p>
        </div>
      </div>

      <div className="main-content-container">
        {isMobile ? children : <div className="main-card">{children}</div>}
      </div>
    </div>
  );
};

export default MainLayout;
